import Pusher from 'pusher-js';

const pusher = new Pusher('62c0f87ea441ffc51986', {
    appId: '1872617',
    secret: '82d0bfbba78e2b1d5e04',
    cluster: 'ap2',
    encrypted: true,
});
export default pusher;